export const MessagePlaceholder = {
  body: 'Enter a Message',
};
